import { useCallback, useEffect } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import * as Analytics from 'analytics/analytics'
import ImageHero from 'components/Common/ImageHero'
import ModalBody from 'LuxKit/Modal/ModalBody'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import { ModalSteps } from '../defaults'

const Content = styled(Group)`
  padding: 0 ${rem(20)};
`

const Header = styled(ImageHero)`
  max-height: ${rem(168)};
`

interface Props {
  onSetNextStep: (step: ModalSteps, isSaveAction?: boolean) => void
  onClose: () => void
}

function TravelPreferencesModalMobileInitial(props: Props) {
  const intl = useIntl()
  const { onSetNextStep, onClose } = props

  const onSetTravelPreferences = useCallback(() => {
    Analytics.trackClientEvent({
      subject: 'intro_modal',
      action: 'completion',
      type: 'interaction',
      category: 'travel_preferences',
    })
    onSetNextStep(ModalSteps.holidayTypes)
  }, [onSetNextStep])

  useEffect(() => {
    Analytics.trackClientEvent({
      subject: 'intro_modal',
      action: 'impression',
      type: 'nonInteraction',
      category: 'travel_preferences',
    })
  }, [])

  return (
    <>
      <ModalBody>
        <Group direction="vertical" gap={20}>
          <Header
            fixedHeight
            brightness={-30}
            gravity="auto"
            fit="center"
            quality="good"
            aspectRatio="5:2"
            id="sei91ly3rbrcugig5179"
          >
            <Heading variant="heading2" align="center" colour="neutral-eight">
              {intl.formatMessage(
                {
                  id: '3n_epHgYta-5xwAyL0KO',
                  defaultMessage: 'Want a <italic>personalised</italic> experience?',
                  description: 'Hero heading for travel preferences mobile initial modal',
                },
                { italic: (chunks: React.ReactNode) => <i key="italic">{chunks}</i> },
              )}
            </Heading>
          </Header>
          <Content direction="vertical" gap={8}>
            <BodyText variant="large" colour="neutral-two">{intl.formatMessage({
              id: 'rMfPkI5ltr4Qodn6XU6J',
              defaultMessage: 'Set your travel preferences to see tailored recommendations, plus a faster search and booking experience.',
              description: 'Description text for travel preferences mobile initial modal',
            })}
            </BodyText>
          </Content>
        </Group>
      </ModalBody>
      <ModalFooter
        actionsLayout="stacked"
        primaryActionProps={{ children: intl.formatMessage({ id: 'BnSVA3BZAfwQF20-v4xX', defaultMessage: 'Set travel preferences', description: 'Action button to start setting travel preferences on the travel preferences page' }), onClick: onSetTravelPreferences }}
        secondaryActionProps={{ children: intl.formatMessage({ id: 'UtWHePrK_uPzKwmPDTU5', defaultMessage: 'Skip for now', description: 'Action button to skip setting travel preferences on the travel preferences page' }), onClick: onClose }}
      />
    </>
  )
}

export default TravelPreferencesModalMobileInitial
